import React from 'react'
import t from 'format-message'
import {BanksInterface} from './components/BanksInterface'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'
import {useParams} from 'react-router'
import {
  BankPage as BankDetails,
  BanksPage as Banks,
  BankEntryPage as BankEntry,
} from '@instructure/quiz-core'

export function BanksPage() {
  useDocumentTitle(t('Banks'))

  return <BanksInterface component={Banks} ariaLabel={t('Banks')} />
}

export function BankDetailsPage() {
  const {bankId} = useParams()

  useDocumentTitle(t('Bank'))

  return <BanksInterface component={BankDetails} bankId={bankId} ariaLabel={t('Bank')} />
}

export function BankEntryPage() {
  const {bankId, bankEntryId} = useParams()

  useDocumentTitle(t('Bank Entry'))

  return (
    <BanksInterface
      component={BankEntry}
      bankId={bankId}
      bankEntryId={bankEntryId}
      ariaLabel={t('Bank entry')}
    />
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the banks module.
 */
export const banksRoutes = [
  {
    index: true,
    element: <BanksPage />,
  },
  {
    path: ':bankId',
    element: <BankDetailsPage />,
  },
  {
    path: ':bankId/bank_entries/:bankEntryId',
    element: <BankEntryPage />,
  },
]
